import { render } from "./MessagesIcon.vue?vue&type=template&id=2f4a4fc5&scoped=true"
import script from "./MessagesIcon.vue?vue&type=script&lang=js"
export * from "./MessagesIcon.vue?vue&type=script&lang=js"

import "./MessagesIcon.vue?vue&type=style&index=0&id=2f4a4fc5&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3011205126/src/emulator.totogidemos.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4a4fc5"]])

export default __exports__